<template>
  <section class="file-uploader-wrap">
    <div class="file-uploader-container">

      <section class="left">
        <h4>Upload Files</h4>

        <div class="uploader-wrap" :class="{ dragging: isDragging }" @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">
          <div class="uploader">
            <div class="icon" @click="triggerFile">
              <i class="fas fa-plus"></i>
            </div>

            <h5>Drag files kesini atau klik untuk upload</h5>

            <p>
              <small>
                tipe file hanya .pdf, .jpg, .jpeg, .png, atau .webp
                dengan ukuran maksimal 5mb
              </small>
            </p>

            <input ref="fileInput" type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.webp" @change="handleUpload"
              style="display:none" />
          </div>
        </div>

        <div class="files-list">
          <div class="files-card" v-for="(item, index) in files" :key="index">
            <div class="icon-card" @click="ubahpdf(item)">
              <div class="bg-white">
                <i v-if="item.type === 'application/pdf'" class="fa-light fa-file-pdf" />

                <i v-else class="fa-light fa-image" />
              </div>
            </div>

            <div class="wrap-detail">
              <p class="namapt">
                {{ item.name }}
              </p>

              <div class="detail-info">
                <small>{{ item.type }}</small>
                <small>{{ item.size }}</small>
              </div>

              <p v-if="!item.isValid" class="error-text">
                {{ item.errorMessage }}
              </p>
            </div>

            <div class="cancelbutton" @click="removeFile(index)">
              <i class="fal fa-times"></i>
            </div>
          </div>
        </div>

        <div class="action-button">
          <button @click="tutupFileUploader">
            batal
          </button>

          <button @click="kirimfiles">
            kirim
          </button>
        </div>
      </section>

      <section class="right">
        <div class="toolbar">
          <h4>Preview Files</h4>
        </div>

        <div class="pdf-wrapper">

          <div v-if="imgsource" class="panzoom-wrapper">
            <div ref="panzoom" class="panzoom-target">
              <img :src="imgsource" class="image-preview" draggable="false" />
            </div>
          </div>

          <PdfViewer v-else-if="pdfDoc" :key="viewerKey" :pdfUrl="pdfDoc" />
        </div>
      </section>

    </div>
  </section>
</template>

<script>
import PdfViewer from "@/models/PdfViewModel2.vue";
import Panzoom from "@panzoom/panzoom";
import "@/assets/css/index.css";

export default {
  name: "FileUploader",

  components: {
    PdfViewer
  },

  emits: ["tutupFileUploader","kirimthesefiles"],

  data() {
    return {
      files: [],
      pdfDoc: null,
      imgsource: null,
      viewerKey: 0,
      isDragging: false,
      panzoomInstance: null
    };
  },

  methods: {
    triggerFile() {
      this.$refs.fileInput.click();
    },

    handleUpload(event) {
      this.addFiles(
        Array.from(event.target.files)
      );
    },

    onDragOver() {
      this.isDragging = true;
    },

    onDragLeave() {
      this.isDragging = false;
    },

    onDrop(event) {
      this.isDragging = false;

      this.addFiles(
        Array.from(event.dataTransfer.files)
      );
    },

    addFiles(fileList) {

      const maxSize =
        50 * 1024 * 1024;

      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "image/webp"
      ];

      fileList.forEach(file => {

        if (
          !allowedTypes.includes(
            file.type
          )
        ) {
          this.files.push({
            name: file.name,
            type: file.type,
            size:
              (file.size / 1024).toFixed(1) +
              " KB",
            isValid: false,
            errorMessage:
              "Tipe file tidak didukung"
          });

          return;
        }

        if (
          file.size > maxSize
        ) {
          this.files.push({
            name: file.name,
            type: file.type,
            size:
              (
                file.size /
                1024 /
                1024
              ).toFixed(2) +
              " MB",
            isValid: false,
            errorMessage:
              "Ukuran file melebihi 10 MB"
          });

          return;
        }

        this.files.push({
          file,
          name: file.name,
          type: file.type,
          size:
            (file.size / 1024).toFixed(1) +
            " KB",
          url:
            URL.createObjectURL(
              file
            ),
          isValid: true
        });
      });
    },

    ubahpdf(item) {

      if (!item.isValid)
        return;

      if (
        item.type ===
        "application/pdf"
      ) {
        this.destroyPanzoom();

        this.imgsource = null;
        this.pdfDoc = item.url;

        this.viewerKey++;
      }

      else if (
        item.type.startsWith(
          "image/"
        )
      ) {
        this.pdfDoc = null;
        this.imgsource =
          item.url;

        this.$nextTick(() => {
          this.initPanzoom();
        });
      }
    },

    initPanzoom() {

      this.destroyPanzoom();

      const el =
        this.$refs.panzoom;

      if (!el) return;

      this.panzoomInstance =
        Panzoom(el, {
          maxScale: 15,
          minScale: 1,
          contain: "outside",
          cursor: "grab"
        });

      el.parentElement.addEventListener(
        "wheel",
        this.panzoomInstance.zoomWithWheel
      );
    },

    destroyPanzoom() {

      if (
        this.panzoomInstance
      ) {
        this.panzoomInstance.destroy();
        this.panzoomInstance =
          null;
      }
    },

    removeFile(index) {
      this.files.splice(
        index,
        1
      );
    },

    tutupFileUploader() {

      this.destroyPanzoom();

      this.files = [];
      this.pdfDoc = null;
      this.imgsource = null;

      this.$emit(
        "tutupfileuploader"
      );
    },

    kirimfiles() {
      //console.log(this.files);
      this.$emit('kirimthesefiles',this.files)
    }
  },

  beforeUnmount() {
    this.destroyPanzoom();
  }
};
</script>